import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../reducers/types";

import {
  getHotelShopSelectedLodging,
  getViewedHotelDetailsProperties,
} from "../../reducer/selectors";
import { MobileHotelPhotoModal } from "./component";

const mapStateToProps = (state: IStoreState) => ({
  lodging: getHotelShopSelectedLodging(state) || undefined,
  viewedHotelDetailsProperties: getViewedHotelDetailsProperties(state),
});

export const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileHotelPhotoModalConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileHotelPhotoModal = connector(MobileHotelPhotoModal);
